import { Row, Col } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';
import Markdown from 'markdown-to-jsx';

const CookbookDish = ({ name, recipe, children }) => {
  const { t } = useTranslator();
  const replaceSpanToOl = ({ children }) => (
    <ol className="recipe">
      <li>{children.slice(3)}</li>
    </ol>
  );

  return (
    <div className="dish">
      <h2 className="title-large semi-bold">{name}</h2>
      <Row>
        <Col md="6">{children}</Col>
        <Col md="6">
          <div className="recipe">
            <p className="semi-bold">{t('mealDetails.methodBox.title')}</p>
            <Markdown
              start="1"
              options={{
                overrides: {
                  span: {
                    component: replaceSpanToOl,
                  },
                },
              }}
            >
              {recipe}
            </Markdown>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CookbookDish;
